<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
              <p class="text-muted font-13 mb-0">Manage digital agreements sent to recipients.</p>
              <b-button variant="primary" size="sm" @click="$router.push('/setup/send-digital-agreement')">
                <feather-icon icon="SendIcon" size="14" class="mr-50" />
                Send Agreement
              </b-button>
            </div>
            <good-table-column-search
              :moduleapi="`${baseApi}/digital-agreements`"
              title="Digital Agreements"
              :columns="columns"
              :formOptions="formOptions"
              :add="false"
              :edit="false"
              :newPage="true"
            >
              <template #customField="{ props }">
                <span v-if="props.column.field === 'status'">
                  <b-badge :variant="statusVariant(props.row.status)">
                    {{ formatStatus(props.row.status) }}
                  </b-badge>
                </span>
              </template>
              <template #action="{ row }">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="mr-1"
                  @click="$router.push(`/setup/digital-agreement/${row.id}`)"
                >
                  View
                </b-button>
                <b-button
                  v-if="row.status === 'pending' || row.status === 'sent'"
                  size="sm"
                  variant="outline-warning"
                  :disabled="resendingId === row.id"
                  @click="handleResend(row)"
                >
                  <b-spinner v-if="resendingId === row.id" small />
                  <span v-else>Resend</span>
                </b-button>
              </template>
            </good-table-column-search>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodTableColumnSearch from '@/components/GoodTableColumnSearch.vue'
import { BButton, BBadge, BSpinner } from 'bootstrap-vue'
import { resendDigitalAgreement } from '@/api/digitalAgreement'

const baseApi = process.env.VUE_APP_APIENDPOINT

export default {
  name: 'DigitalAgreementList',
  components: {
    GoodTableColumnSearch,
    BButton,
    BBadge,
    BSpinner,
  },
  data() {
    return {
      baseApi,
      resendingId: null,
      formOptions: {},
      columns: [
        {
          label: 'Recipient',
          field: 'recipient_name',
          filterOptions: { enabled: true, placeholder: 'Search recipient' },
        },
        {
          label: 'Email',
          field: 'recipient_email',
          filterOptions: { enabled: true, placeholder: 'Search email' },
        },
        {
          label: 'Subject',
          field: 'subject',
          filterOptions: { enabled: true, placeholder: 'Search subject' },
        },
        {
          label: 'Status',
          field: 'status',
          filterOptions: { enabled: true, placeholder: 'Search status' },
        },
        {
          label: 'Sent At',
          field: 'sent_at',
          type: 'datetime',
          time: true,
          filterOptions: { enabled: true, placeholder: 'Search date' },
        },
        {
          label: 'Signed At',
          field: 'signed_at',
          type: 'datetime',
          time: true,
          filterOptions: { enabled: true, placeholder: 'Search date' },
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    formatStatus(status) {
      if (!status) return 'Pending'
      return status.charAt(0).toUpperCase() + status.slice(1)
    },
    statusVariant(status) {
      const map = {
        pending: 'warning',
        sent: 'info',
        signed: 'success',
        rejected: 'danger',
        expired: 'secondary',
      }
      return map[status] || 'secondary'
    },
    async handleResend(row) {
      this.resendingId = row.id
      try {
        await resendDigitalAgreement(row.id)
        this.$bvToast.toast('Agreement resent successfully.', { title: 'Success', variant: 'success' })
      } catch (err) {
        this.$bvToast.toast(err.response?.data?.message || 'Failed to resend agreement.', {
          title: 'Error',
          variant: 'danger',
        })
      } finally {
        this.resendingId = null
      }
    },
  },
}
</script>
